export function formatCurrency(value: string | null) {
  if (!value) {
    return "$0.00";
  }

  if (value?.startsWith("-")) {
    return "-$".concat(value.slice(1));
  }

  return "$".concat(value);
}

export function formatCents(value: string | number) {
  // return $0.00 if not a number
  if (Number.isNaN(Number(value))) {
    return "$0.00";
  }
  // convert numeric cent value to dollar string with two decimal places
  const dollarString = (Number(value) / 100).toFixed(2);

  // format and return the value
  return formatCurrency(dollarString);
}
